/** @jsxFrag React.Fragment */
import * as React from 'react';


import {
  getPhaseOneOverride,
  useEnterpriseAdminPermissions,
} from 'bundles/enterprise-admin-roles/components/EnterprisePermissionsProvider';
import type { RequiredPermission } from 'bundles/enterprise-admin-roles/types';

type Props = RequiredPermission & {
  phaseOneOverride?: boolean;
  substituteComponent?: React.ReactElement;
};

const EnterprisePermissionsRequired: React.FC<Props> = (
  { children, phaseOneOverride, substituteComponent, ...permission },
  context = {}
) => {
  const { hasPermission } = useEnterpriseAdminPermissions();
  const implicitPhaseOneOverridePermission = getPhaseOneOverride(permission.domain, permission.domainId);
  if (!phaseOneOverride && !implicitPhaseOneOverridePermission && !hasPermission(permission)) {
    return <>{substituteComponent}</>;
  }

  return <>{children}</>;
};

export default EnterprisePermissionsRequired;
